import { Inspect } from '../../../../components/Inspect'

export const InspectQOC = ({ goBackToPage, pages, values }) => {
  const allegationDetails = [
    {
      heading: 'Allegation type',
      field_name: '',
      value: 'Quality of care',
      omitEdit: true
    },
    {
      heading: 'Is victim in immediate danger?',
      field_name: 'immediate_danger_yn',
      value: values.immediate_danger_yn
    }
  ]

  return Inspect({ goBackToPage, pages, values, allegationDetails })
}

export default InspectQOC
